// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DiWSQQ6sq6IZk7HOD2A8{flex-direction:column;gap:8px;display:flex}.YZS_DjBtLbgeucCBJqQF{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;align-items:center;width:-webkit-fit-content;width:fit-content;padding:4px 8px;display:flex}.lW09BizxMmgPM3bTx61m{margin-left:4px}.FXNQmdhyfVwxN_MFAmOS{background:var(--content-neutral-primary);border-radius:50%;width:2px;height:2px;margin:0 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phoneList": `DiWSQQ6sq6IZk7HOD2A8`,
	"phoneItem": `YZS_DjBtLbgeucCBJqQF`,
	"aircallIcon": `lW09BizxMmgPM3bTx61m`,
	"dot": `FXNQmdhyfVwxN_MFAmOS`
};
export default ___CSS_LOADER_EXPORT___;
